import { Component, Input } from '@angular/core';
import {
  GymDay,
  ExceptionalOpeningHoursV2,
  gymDays,
  OpeningHoursV2,
  OpeningTimeRange,
  OpeningTimeSentinel,
} from '../../../model/opening-hours';
import { OpeningHourUtil } from '../../../util/opening-hour-util';

@Component({
  selector: 'gymfinder-changelog-opening-hours',
  templateUrl: './changelog-opening-hours.component.html',
  styleUrls: ['./changelog-opening-hours.scss'],
  standalone: false,
})
export class ChangelogOpeningHoursComponent {
  @Input()
  openingHoursV2: OpeningHoursV2;

  days = gymDays;

  formatDay(day: GymDay): string {
    if (day === 'publicHoliday') return 'Public holiday';
    return day.charAt(0).toUpperCase() + day.slice(1);
  }

  formatDayValue(value: OpeningTimeRange[] | OpeningTimeSentinel): string {
    return OpeningHourUtil.formatDayValue(value);
  }

  formatPeriod(exception: ExceptionalOpeningHoursV2): string {
    return `${exception.period.startDate} – ${exception.period.endDate}`;
  }

  formatExceptionValue(exception: ExceptionalOpeningHoursV2): string {
    return OpeningHourUtil.formatDayValue(exception.time);
  }
}
